// Packages
import Vue from 'vue';

// Core
import { YouTubePlayer } from '~scripts/core/YouTubePlayer';

// Blocks
import initSubscribeForm from '~scripts/blocks/subscribe-form';
import forumModalVideo from '~scripts/blocks/vue/ForumModalVideo.vue';

// Components
import { modalHelpers } from '~scripts/components/modals';

//
// VIDEO
//
// Закрытие модального окна по клику вне контента
const modals = document.querySelectorAll('.js-modal-video');

modals.forEach((modal) => {
  modal.addEventListener('click', (e) => {
    const video = modal.querySelector('.js-video');
    const form = modal.querySelector('.js-event-video__form');
    const isFormHidden = form?.classList.contains('event-video__form--hidden');
    const isVideoHidden = video.classList.contains('video--hidden');

    if (!e.target.closest('.js-event-video__form') && isVideoHidden) {
      modalHelpers.close(modal);
    }

    if (!e.target.closest('.video-content') && (isFormHidden || !form)) {
      modalHelpers.close(modal);
    }
  });
});

// Предотвращение открытия модального окна по клику на ссылки
const programCardsLinks = document.querySelectorAll('.js-program-card a');

programCardsLinks.forEach((link) => {
  link.addEventListener('click', (e) => {
    e.stopPropagation();
  });
});

const modalBackgroundVideo = document.querySelectorAll('.js-modal-background-video');
modalBackgroundVideo.forEach((video) => {
  new Vue({
    el: video,
    name: 'forumModalVideo',
    components: {
      forumModalVideo,
    },
  });
});

const videoItems = document.querySelectorAll('.js-video');
const subscribeForms = document.querySelectorAll('.js-subscribe-form');
const storage = window.localStorage;
const showVideoWithoutForm = document.getElementById('main').dataset.showVideoWithoutForm === 'true';

document.addEventListener('form-send', () => {
  storage.setItem('forum2023FormSubmitted', 1);

  subscribeForms.forEach((form) => {
    const formWrapper = form.closest('.js-event-video__form');
    formWrapper?.classList.add('event-video__form--hidden');
  });
});

const showModalForm = () => {
  subscribeForms.forEach((form) => {
    const formWrapper = form.closest('.js-event-video__form');

    if (!storage.getItem('forum2023FormSubmitted')) {
      formWrapper?.classList.remove('event-video__form--hidden');
    } else {
      videoItems.forEach((el) => el.classList.remove('video--hidden'));
    }
  });
};

subscribeForms.forEach((form) => {
  initSubscribeForm(form);
  showModalForm();
});

const handleOpenModal = (e, playersList) => {
  const modal = e.target;
  const videoKey = modal.dataset.video;
  const isModalWithoutForm = modal.id === 'manifesto' || modal.id === 'mikhailTansky';
  const isFormSubmitted = storage.getItem('forum2023FormSubmitted');

  if (isModalWithoutForm || isFormSubmitted || showVideoWithoutForm) {
    try {
      playersList[videoKey].playVideo();
    } catch {
      console.warn('YouTube player is not ready');
    }
  }
};

const handleCloseModal = (e, playersList) => {
  const videoKey = e.target.dataset.video;
  playersList[videoKey].pauseVideo();
};

const handleFormSend = (e, playersList) => {
  const modal = e.target.closest('.js-modal-video');
  const videoKey = modal?.dataset.video;

  if (videoKey) {
    try {
      playersList[videoKey].playVideo();
    } catch {
      console.warn('YouTube player is not ready');
    }
  }
};

const playerOptions = {
  videoElements: '.js-video',
  handleFormSend: handleFormSend,
  handleOpenModal: handleOpenModal,
  handleCloseModal: handleCloseModal,
};

const players = await new YouTubePlayer(playerOptions);
players.init();
